export default __webpack_public_path__ + "static/santo-f68dcd1b82660751b3eb644784d5a8f1.jpg";